import React, { useEffect, useRef } from "react";
import EventManager from "./common/event-manager/EventManager";
import Navigator from "./components/navigator/Navigator";
import { DeviceMap } from "./components/device-map/DeviceMap";
import { DeviceOnlineStatistics } from "./components/device-online-statistics/DeviceOnlineStatistics";
import { DeviceList } from "./components/device-list/DeviceList";
import { DeviceAlarmStatistics } from "./components/device-alarm-statistics/DeviceAlarmStatistics";
import DeviceOnlineDuration from "./components/device-online-duration/DeviceOnlineDuration";
import BorderDecoratedCard from "./common/border-decorated-card/BorderDecoratedCard";
import DeviceAnalyse from "./components/device-analyse/DeviceAnalyse";
import TransitionCarousel from "./common/transition-carousel/TransitionCarousel";
import { DeivceOnlineDurationWrapper, DeviceAlarmStatisticsWrapper, DeviceAnalyseWrapper, DeviceListWrapper, DeviceMapWrapper, DeviceOnlineStatisticsWrapper, OverviewBigScreenContent, OverviewBigScreenInnerWrapper, OverviewBigScreenWrapper, ScreenBorder, ScreenBorderTop, ScreenTitleBar } from "./OverviewBigScreen.styled";

interface OverviewBigScreenProps {
    
}

const OverviewBigScreen: React.FC<OverviewBigScreenProps> = (props)=> {
    // event manager
    let eventManagerRef = useRef(new EventManager());

    // effect
    useEffect(()=> {
        let originalBackground = document.body.style.backgroundColor;
        document.body.style.backgroundColor = ' background-color: rgb(15, 53, 109);';
        return ()=> {
            document.body.style.backgroundColor = originalBackground;
        };
    }, []);

    // render
    return (
        <OverviewBigScreenWrapper>
            <OverviewBigScreenInnerWrapper>
                <ScreenTitleBar>
                    <Navigator selected="OVERVIEW"/>
                </ScreenTitleBar>

                <ScreenBorderTop src="/static/images/big-screen/v2/overview-title-background.png"/>
                <ScreenBorder src="/static/images/big-screen/v2/overview-border.png"/>

                <OverviewBigScreenContent>

                   <DeviceMapWrapper>
                        <DeviceMap eventManager={eventManagerRef.current} />
                    </DeviceMapWrapper>

                    <DeviceOnlineStatisticsWrapper>
                        <BorderDecoratedCard
                            titleCn="设备在线情况"
                            titleEn="ONLINE STATISTICS"
                            style={{width: '100%', height: '100%'}}
                            styleTitleCn={{transform: 'translateY(-13px)'}}
                            styleContent={{transform: 'translateY(-22px)'}}
                        >
                            <DeviceOnlineStatistics />
                        </BorderDecoratedCard >

                    </DeviceOnlineStatisticsWrapper>

                    <DeviceListWrapper>
                        <BorderDecoratedCard
                            titleCn="设备列表"
                            titleEn="DEVICE LIST"
                            style={{width: '100%', height: '100%'}}
                            styleTitleCn={{transform: 'translateY(8px)'}}
                            styleContent={{height:'95%'}}
                        >
                            <DeviceList eventManager={eventManagerRef.current}/>
                        </BorderDecoratedCard>
                    </DeviceListWrapper>

                    <DeivceOnlineDurationWrapper>
                        <BorderDecoratedCard
                            titleCn=""
                            titleEn=""
                            style={{position: 'absolute', zIndex: '99', width: '100%', height: '100%'}}
                        >
                        </BorderDecoratedCard>

                        <TransitionCarousel switchInterval={10 * 1000} switchOffset={3000} style={{position: 'absolute', zIndex: '100', width: '100%', height: '100%'}}>
                            <BorderDecoratedCard
                                key="total-online-time"
                                titleCn="设备时长统计"
                                titleEn="DURATION STATISTICS"
                                titleBackgroundHide={true}
                                style={{width: '100%', height: '100%'}}
                                styleTitleCn={{transform: 'translateY(-10px)'}}

                            >
                                <DeviceOnlineDuration eventManager={eventManagerRef.current}/>
                            </BorderDecoratedCard>
                            <BorderDecoratedCard
                                key="today-online-time"
                                titleCn="今日在线时长"
                                titleEn="TODAY DURATION STATISTICS"
                                titleBackgroundHide={true}
                                style={{width: '100%', height: '100%'}}
                                styleTitleCn={{transform: 'translateY(-10px)'}}
                            >
                                <DeviceOnlineDuration eventManager={eventManagerRef.current} today={true}/>
                            </BorderDecoratedCard>
                        </TransitionCarousel>
                    </DeivceOnlineDurationWrapper>

                    <DeviceAlarmStatisticsWrapper>
                        <BorderDecoratedCard
                                titleCn="告警事件"
                                titleEn="ALARMING EVENTS"
                                style={{width: '100%', height: '100%'}}
                                styleTitleCn={{transform: 'translateY(8px)'}}
                                styleContent={{height:'95%'}}

                            >
                            <DeviceAlarmStatistics />
                        </BorderDecoratedCard>
                    </DeviceAlarmStatisticsWrapper>

                    <DeviceAnalyseWrapper>
                        <BorderDecoratedCard
                                key="overall-analyse"
                                titleCn="数据统计分析"
                                titleEn="STATISTICS ANALYSE"
                                style={{width: '100%', height: '100%'}}
                                styleTitleCn={{transform: 'translateY(1px)'}}
                            >
                            <DeviceAnalyse />
                        </BorderDecoratedCard>
                    </DeviceAnalyseWrapper>
                </OverviewBigScreenContent>

            </OverviewBigScreenInnerWrapper>

        </OverviewBigScreenWrapper>
    )
};

export default OverviewBigScreen;